import { Theme, ThemedText, ThemedView } from "@app/theme";
import { Image } from 'react-native'
import Button from '@sharedComponents/Button/Button';
import { addCommasToNumber, getDateMonthYearFromEpochFromMicroseconds } from "@app/utils";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import { useState } from "react";
import { Info } from "@app/sharedComponents/Icons/Icons";
import { useSelector } from "react-redux";
import { RootState } from "@app/store/newstore";
import { getApplicationId } from "@app/screens/FetchPortfolio/utils";
import axios from "axios";
import { endpoints } from "@app/api/apis";
import { getNextRoute } from "@app/navigationApp/navigationUtil";
import handleApiErr from "@app/helper/handleApiErr";
import { useAppDispatch } from "@app/store/hooks";
import { showErrorSheet } from "@app/store/slices/errorSlice";
import ROUTE from "@app/navigationApp/routes";
import PledgeIconNew from "@app/assets/svg/PledgeIconNew";
import { useTheme } from "@shopify/restyle";
const IMAGE1 = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_assets.png'

const EditLimit = ({
    route,
    navigation,
    pledgeData
}: {
    route: any;
    navigation: any;
    pledgeData: any;
}) => {
    const [showEditLimit, setShowEditLimit] = useState(false);
    const [editLimitLoader, setEditLimitLoader] = useState(false);
    const { userDetails } = useSelector((state: RootState) => state.auth);
    const dispatch = useAppDispatch();
    const { colors } = useTheme<Theme>();

    let dateToPick = 0
    const karvyFetchDate = pledgeData?.stepResponseObject?.repositoryAssetMetadataMap?.KARVY?.casFetchDate;
    const camsFetchDate = pledgeData?.stepResponseObject?.repositoryAssetMetadataMap?.CAMS?.casFetchDate;
    if (karvyFetchDate === null) { dateToPick = camsFetchDate }
    else if (camsFetchDate === null) { dateToPick = karvyFetchDate }
    else { dateToPick = Math.max(karvyFetchDate, camsFetchDate) }
    let date = dateToPick === null ? '' : getDateMonthYearFromEpochFromMicroseconds(dateToPick);

    const handleEditLimit = async () => {
        setEditLimitLoader(true);
        try {
            const applicationId = await getApplicationId(userDetails?.linkedApplications[0]?.applicationId);
            const enabledRTAFlowResponse = await axios.get(`${endpoints.checkEnabledRTA}${applicationId}`);
            const continueEditResponse = await axios.get(`${endpoints.editLimitRoute}${applicationId}`);
            const isFromMFCentral = enabledRTAFlowResponse?.data?.enabledRtaFlow === "MfCentralFlow"
            setShowEditLimit(false);
            if (isFromMFCentral) {
                navigation.navigate(ROUTE.MFC_FETCH_ANCHOR);
            } else {
                const currentStepId = continueEditResponse?.data?.updatedApplicationObj?.currentStepId
                const route = await getNextRoute(currentStepId, userDetails?.linkedApplications[0]?.applicationState, userDetails?.linkedApplications[0]?.stepStatusMap);
                navigation.navigate(route)
            }
        } catch (err: any) {
            if (err?.data?.statusCode && handleApiErr(err)) {
                setShowEditLimit(false);
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: err?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                    errorHeading: err?.data?.header,
                    showErrorHeading: true,
                    btnName: 'Ok, got it!',
                }))
            }
        }
        setEditLimitLoader(false);
    }

    const handleUnlockLimit = async () => {
        navigation.navigate(ROUTE.KYC_STEPPER)    
    }

    return (
        <ThemedView style={{ padding: 16, marginBottom: 16 }} backgroundColor="bg-fill-primary" borderBottomWidth={1} borderColor={'border-secondary'}>
            <ThemedText
                variant="h3s"
                color="text-primary"
            >
                Unlock additional credit limit
            </ThemedText>
            <ThemedText
                variant="b4r"
                color="text-secondary"
            >
                Last fetched on {date === null ? '' : date}
            </ThemedText>
            <ThemedView borderWidth={1} borderColor="border-secondary" borderRadius="md" style={{ marginTop: 16 }}>
                <ThemedView flexDirection="row" style={{ padding: 16 }}>
                    <ThemedView style={{ height: 52, width: 52, alignItems: 'center', justifyContent: 'center', backgroundColor: colors['bg-fill-emphasis-primary-1'], borderRadius: 8, marginRight: 12 }}>
                        <PledgeIconNew bgColor={colors['bg-fill-emphasis-primary-1']} color1={colors['icon-action-primary']} color2={colors['icon-emphasis-primary']} />
                    </ThemedView>
                    <ThemedView>
                        <ThemedText
                            variant="b3r"
                            color="text-secondary"
                        >
                            Selected credit limit
                        </ThemedText>
                        <ThemedText
                            variant="b1b"
                            color="text-success"
                            style={{ fontSize: 24 }}
                        >
                            ₹{addCommasToNumber(pledgeData?.stepResponseObject?.requestCreditLimit)}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView style={{ paddingVertical: 6, paddingHorizontal: 20, borderTopWidth: 1 }} borderColor='border-secondary'>
                    <ThemedText
                        variant="b3r"
                        color="text-secondary"
                    >
                        Available limit: ₹{addCommasToNumber(pledgeData?.stepResponseObject?.availableCreditLimit)}
                    </ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView flexDirection="row" style={{ marginTop: 16 }}>
                <ThemedView flex={0.8}>
                    <Button
                        eventName={'EDIT_LIMIT_BUTTON'}
                        label={'Edit limit'}
                        handlePress={() => {
                            setShowEditLimit(true)
                        }}
                        type={'OUTLINED'}
                        size='MD'
                        bg='bg-primary'
                        textColor='text-secondary'
                        additionalProperties={{
                            page : 'increase_limit_landing_page'
                        }}
                    />
                </ThemedView>
                <ThemedView style={{ padding: 4 }}></ThemedView>
                <ThemedView flex={1}>
                    <Button
                        eventName={'UNLOCK_LIMIT_BUTTON'}
                        label={'Unlock limit'}
                        handlePress={() => {
                            handleUnlockLimit()
                        }}
                        type={'SOLID'}
                        size='MD'
                        bg='bg-primary'
                        textColor='text-primary'
                        additionalProperties={{
                            page : 'increase_limit_landing_page'
                        }}
                    />
                </ThemedView>
            </ThemedView>
            <BottomSheetContainer
                isVisible={showEditLimit}
                closeOnBackdropPress={false}
                showCloseIcon={true}
                close={() => {
                    setShowEditLimit(false)
                }}
                onClose={() => {
                    setShowEditLimit(false)
                }}
                dragComponent={<ThemedView style={{ height: 12 }} />}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                containerStyle={{ borderTopRightRadius: 16, borderTopLeftRadius: 16 }}
            >
                <ThemedView style={{ alignItems: 'center', paddingTop: 24, paddingHorizontal: 16, paddingBottom: 16 }}>
                    <Info size={60} weight="fill" color="#f9bd21" />
                    <ThemedText variant="h5s" color="text-primary" style={{ marginTop: 24, marginBottom: 24, textAlign: 'center' }}>
                        Are you sure you want to edit your limit? This will reset your selected limit
                    </ThemedText>
                    <Button
                        label={'Yes, continue to edit limit'}
                        handlePress={() => {
                            handleEditLimit();
                        }}
                        type={'SOLID'}
                        size='MD'
                        bg='bg-primary'
                        textColor='text-primary'
                        buttonLoader={editLimitLoader}
                    />
                    <ThemedView style={{ marginTop: 12 }} />
                    <Button
                        label={'No, continue with selected limit'}
                        handlePress={() => {
                            setShowEditLimit(false)
                        }}
                        type={'OUTLINED'}
                        size='MD'
                        bg='bg-primary'
                        textColor='text-primary'
                    />
                </ThemedView>
            </BottomSheetContainer>
        </ThemedView>
    )
}

export default EditLimit;